import { useMountEffect } from "@react-hookz/web";
// cspell: ignore tinypass
import { isValidUrl } from "scmp-sdk";

import { sendGTMSubscribeVariables } from "scmp-app/components/tracking/google-tag-manager/apis";
/**
 * Handle the tracking from Piano template
 * GTM including impression and click
 */
export const useRosettaPianoTemplateTracking = () => {
  useMountEffect(() => {
    const handlePianoTemplateTracking = (event: Event) => {
      if (!isValidUrl(event.origin)) return;

      const hostname = new URL(event.origin).hostname;
      if (!(hostname.includes("piano") || hostname.includes("tinypass"))) {
        return;
      }

      if (event.data.type !== "tracking") return;

      const { gtm: gtmData } = event.data;
      if (gtmData) {
        const { subscribe } = gtmData;
        if (subscribe) sendGTMSubscribeVariables(subscribe);
      }
    };

    window.addEventListener("message", handlePianoTemplateTracking);
    return () => {
      window.removeEventListener("message", handlePianoTemplateTracking);
    };
  });
};

type Event = {
  data: {
    gtm?: {
      subscribe?: Record<string, unknown>;
    };
    type?: string;
  };
  origin: string;
};
